module.exports = __webpack_public_path__ + "img/mask-2.38b02698.svg";